let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fsXD3")).then(() => parcelRequire('aBRz9'));